import React from "react";
import { Link, NavLink } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import Logo from "./Logo";

export default function Navbar() {
  const { lang, setLang, t } = useI18n();

  const links = [
    { to: "/", label: t.nav.home, end: true },
    { to: "/klassiekers", label: t.nav.classics },
    { to: "/ruimtes", label: t.nav.rooms },
    { to: "/aanpak", label: t.nav.approach },
    { to: "/contact", label: t.nav.contact },
  ];

  return (
    <header
      data-testid="site-nav"
      className="sticky top-0 z-40 backdrop-blur-md bg-stoel-paper/85 border-b border-stoel-line/60"
    >
      <div className="stoel-container flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="brand-logo"
          aria-label="DeStoel.com"
          className="flex items-center gap-3 group text-stoel-ink"
        >
          <Logo linked={false} size="header" />
          <span className="flex items-baseline gap-2">
            <span className="text-xl md:text-[22px] font-light tracking-tight text-stoel-ink">
              DeStoel.com
            </span>
            <span className="hidden sm:block text-[10px] uppercase tracking-[0.3em] text-stoel-walnut/70">
              est. 2001
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-${l.to === "/" ? "home" : l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${
                  isActive
                    ? "text-stoel-terracotta"
                    : "text-stoel-ink hover:text-stoel-terracotta"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div
          data-testid="lang-toggle"
          className="flex items-center text-sm tracking-wider select-none"
        >
          <button
            data-testid="lang-nl"
            onClick={() => setLang("nl")}
            className={`px-2 py-1 transition-colors ${
              lang === "nl"
                ? "text-stoel-ink font-medium"
                : "text-stoel-ink/40 hover:text-stoel-ink"
            }`}
            aria-pressed={lang === "nl"}
          >
            NL
          </button>
          <span className="text-stoel-line">|</span>
          <button
            data-testid="lang-en"
            onClick={() => setLang("en")}
            className={`px-2 py-1 transition-colors ${
              lang === "en"
                ? "text-stoel-ink font-medium"
                : "text-stoel-ink/40 hover:text-stoel-ink"
            }`}
            aria-pressed={lang === "en"}
          >
            EN
          </button>
        </div>
      </div>

      {/* Mobile nav */}
      <nav className="md:hidden border-t border-stoel-line/40">
        <div className="stoel-container flex overflow-x-auto py-2 gap-5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`mobile-nav-${l.to === "/" ? "home" : l.to.replace("/", "")}`}
              className={({ isActive }) =>
                `text-xs tracking-wide whitespace-nowrap ${
                  isActive ? "text-stoel-terracotta" : "text-stoel-ink/70"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
}
